<div [formGroup]="form" class="flex-fill">
  @if (formfield.controlType === 'input' || formfield.controlType === 'select') {
    <div class="flex-fill">
      <mat-form-field class="flex-fill">
        <mat-label>{{ formfield.label }}</mat-label>
        @if (formfield.controlType === 'input') {
          <input
            [type]="formfield.type"
            matInput
            [formControlName]="formfield.controlName"
            [required]="formfield.required"
          />
        }
        @if (form.controls[formfield.controlName].hasError('max')) {
          <mat-error>
            <strong>{{ 'labels.commons.Maximum Value must be' | translate }} {{ formfield.max }}</strong>
          </mat-error>
        }
        @if (form.controls[formfield.controlName].hasError('min')) {
          <mat-error>
            <strong>{{ 'labels.commons.Minimum Value must be' | translate }} {{ formfield.min }}</strong>
          </mat-error>
        }
        @if (formfield.controlType === 'select') {
          <mat-select [formControlName]="formfield.controlName" [required]="formfield.required">
            @for (option of formfield.options.data; track option) {
              <mat-option [value]="option[formfield.options.value]">
                {{ option[formfield.options.label] }}
              </mat-option>
            }
          </mat-select>
        }
        @if (form.controls[formfield.controlName].hasError('required')) {
          <mat-error>
            {{ formfield.label }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>
  }

  @if (formfield.controlType === 'datepicker') {
    <mat-form-field class="flex-fill" Fill (click)="datePicker.open()">
      <mat-label>{{ formfield.label }}</mat-label>
      <input
        matInput
        [matDatepicker]="datePicker"
        [min]="formfield.minDate"
        [max]="formfield.maxDate"
        [formControlName]="formfield.controlName"
        [required]="formfield.required"
      />
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
      @if (form.controls[formfield.controlName].hasError('required')) {
        <mat-error>
          {{ formfield.label }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
    </mat-form-field>
  }

  @if (formfield.controlType === 'datetimepicker') {
    <mat-form-field class="flex-fill" Fill (click)="datePicker.open()">
      <mat-label>{{ formfield.label }}</mat-label>
      <input
        matInput
        type="datetime-local"
        [min]="formfield.minDate"
        [max]="formfield.maxDate"
        [formControlName]="formfield.controlName"
        [required]="formfield.required"
      />
      @if (form.controls[formfield.controlName].hasError('required')) {
        <mat-error>
          {{ formfield.label }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
    </mat-form-field>
  }

  @if (formfield.controlType === 'checkbox') {
    <mat-checkbox
      labelPosition="before"
      [checked]="formfield.value"
      [formControlName]="formfield.controlName"
      [required]="formfield.required"
    >
      {{ formfield.label }}
    </mat-checkbox>
  }
</div>
